import React, { useEffect, useState } from 'react'
import { sendRequest } from '../requests/useRequest';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { getGlobalCredit } from '../../services/banking/banking'
import { useRef } from 'react';
import { getInformationAgreement } from '../../services/company/company';
import { Tag } from 'primereact/tag';
import { pyrsa } from '../../constant/globalConstantsTypeClients'

import * as XLSX from 'xlsx';




export const useReportCxc = () => {

    let layoutVersion = localStorage.getItem('layout_version');
    const _urlClient = localStorage.getItem('url_helen');



    const [loadingTotalIngress, setLoadingTotalIngress] = useState(false);
    const [loadingTableClients, setLoadingTableClients] = useState(false);

    const [lblTotalIngress, setLblTotalIngress] = useState(0.0);
    const [lblTotalPaidIngress, setLblPaidIngress] = useState(0.0);
    const [lblOutSideBalance, setLblOutSideBalance] = useState(0.0);
    const [lblTotalPatient, setLblTotalPatient] = useState(0);
    const [lblTotalClients, setLblTotalClients] = useState(0);
    const [detailTransactionsByClients, setDetailTransactionsByClients] = useState([]);
    const [listDetailTransactionsByClients, setListDetailTransactionsByClients] = useState([]);


    // * FILTERS
    const [filterCredit, setFilterCredit] = useState(false);
    const [filterAccount, setFilterAccount] = useState(false);
    const [filterPayment, setFilterPayment] = useState(false);
    const [filterPendingPayment, setFilterPendingPayment] = useState(false);
    const [filterInvoiced, setFilterInvoiced] = useState(false);
    const [filterPendigInvoiced, setFilterPendigInvoiced] = useState(false);
    const [filterPreInvoice, setFilterPreInvoice] = useState(false);
    const [filterPpd, setFilterPpd] = useState(false);
    const [filterPue, setFilterPue] = useState(false);


    // ? FILTER PAY METHODS
    const [filterAmount, setFilterAmount] = useState(false);
    const [filterAmountCredit, setFilterAmountCredit] = useState(false);
    const [filterAmountDebit, setFilterAmountDebit] = useState(false);
    const [filterAmountTcredit, setFilterAmountTcredit] = useState(false);
    const [filterAmountTrasferencia, setFilterAmountTrasferencia] = useState(false);


    const [createSweet] = useSweetAlert();

    const [dateStart, setDateStart] = useState('');
    const [dateEnd, setDateEnd] = useState('');

    //*DOWNLOAD REPORTS
    const [loadingIdR, setLoadingIdR] = useState(null);
    const [companyInfo, setCompanyInfo] = useState([]);

    // * CONFIGURATION AGREEMENTS
    const [filterId, setFilterId] = useState(0)
    const [valuId, setValuId] = useState(0)
    const [listAgreement, setListAgreement] = useState([])
    const msgs = useRef(null);
    const [dataViewCompany, setDataViewCompany] = useState(false)


    const [loadingView2, setLoadingView2] = useState(false)
    const [loadingView1, setLoadingView1] = useState(false)
    const [searchQuery, setSearchQuery] = useState("");
    const [setsearchView1, setSetsearchView1] = useState(false)

    // * CONFIGURATION CHART GLOBAL
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [visible, setVisible] = useState(false);

    // * CONFIGURATION FILTER DATA TABLE
    const [expandedRows, setExpandedRows] = useState(null);
    const [expandedRows2, setExpandedRows2] = useState(null);
    const [globalFilter, setGlobalFilter] = useState(null)
    const [globalFilter2, setGlobalFilter2] = useState(null);
    const [nameCompany, setNameCompany] = useState("")
    const [paymentType, setPaymentType] = useState(null);


    // *METHODS
    const GetReportCxC = async (dateStart, dateEnd, _id_client = null, _id_agreement = null, _loading = false, _view1 = false, payment_type = null) => {
        console.log("🚀 ~ GetReportCxC ~ dateStart:", dateStart)
        console.log("🚀 ~ GetReportCxC ~ dateEnd:", dateEnd)
        console.log("🚀 ~ GetReportCxC ~ _id_client:", _id_client)
        console.log("🚀 ~ GetReportCxC ~ _id_agreement:", _id_agreement)
        console.log("🚀 ~ GetReportCxC ~ _loading:", _loading)
        console.log("🚀 ~ GetReportCxC ~ _view1:", _view1)





        handleUpdateLoadings(true);
        setLoadingView1(true)
        setLoadingView2(_loading)
        setSetsearchView1(_view1)

        let query = [];

        if (payment_type !== null) query.push(`payment_type=${payment_type}`);
        if (_id_client !== null) query.push(`id_company=${_id_client}`);
        if (_id_agreement !== null) query.push(`id_agreement=${_id_agreement}`);

        const queryString = query.length > 0 ? `?${query.join("&")}` : "";

        const Response = await GlobalRequest(
            "GET",
            `Reports/GetReportCxC/${dateStart}/${dateEnd}${queryString}`,
            "Reporte"
        );


        if (Response !== null) {
            setLblTotalIngress(number_format((Response?.totalIngress ?? 0), 2));
            setLblOutSideBalance(number_format((Response?.totalPending ?? 0), 2));
            setLblPaidIngress(number_format((Response?.totalPaids ?? 0), 2));

            setLblTotalClients(Response?.totalClients ?? 0);
            setDetailTransactionsByClients(Response?.detailTransactionsByClients);
            setListDetailTransactionsByClients(Response?.detailWorkOrderByClients);
            setLblTotalPatient(Response?.detailTransactionsPercentageBilling?.totalPatient ?? 0);

            setLoadingView2(false)
            setLoadingView1(false)

        }
        else {
            createSweet("warning", "warning", "Opss..", "Sin información detallada");
        }

        handleUpdateLoadings(false);
    }


    // *USE EFFECT
    useEffect(() => {

        const today = new Date();
        const _Year = today.getFullYear();
        let _Month = today.getMonth() + 1;
        _Month = _Month < 10 ? `0${_Month}` : _Month;

        const startDate = `${_Year}-${_Month}-01`;
        const lastDate = new Date(_Year, _Month, 0);
        const endDate = `${_Year}-${_Month}-${lastDate.getDate().toString().padStart(2, '0')}`;

        setDateStart(startDate);
        setDateEnd(endDate);

        const getAllInitData = async () => {
            await GetReportCxC(startDate, endDate);
            await GetReportCredit(startDate, endDate);
        };

        getAllInitData();
    }, []);

    // ? EFFECTS
    useEffect(() => {

        calcularTotal();

    }, [filterCredit, filterAccount, filterPayment, filterPendingPayment, filterInvoiced, filterPendigInvoiced, filterPreInvoice, filterPpd, filterPue, listDetailTransactionsByClients, filterAmount, filterAmountCredit, filterAmountDebit, filterAmountTcredit, filterAmountTrasferencia]);


    // * HANDLE METHODS
    const handleUpdateLoadings = (updateStatus) => {
        setLoadingTotalIngress(updateStatus);
        setLoadingTableClients(updateStatus);
    }



    const handleFilterByClient = async (_id_client, _valid, _loading = false, _view1 = false) => {
        console.log("🚀 ~ handleFilterByClient ~ _valid:", _valid)
        let _start = dateStart;
        let _end = dateEnd;
        var _bool = false

        if (_valid) {

            _bool = true
        }
        setDataViewCompany(_bool)
        searchAgreement(_id_client)
        //  setSetsearchView1(_valid)


        if (!_start || !_end) {
            console.warn("Fechas no definidas, usando mes actual como fallback");

            const today = new Date();
            const _Year = today.getFullYear();
            let _Month = today.getMonth() + 1;
            _Month = _Month < 10 ? `0${_Month}` : _Month;

            _start = `${_Year}-${_Month}-01`;
            const lastDate = new Date(_Year, _Month, 0);
            _end = `${_Year}-${_Month}-${lastDate.getDate().toString().padStart(2, '0')}`;

            setDateStart(_start);
            setDateEnd(_end);
        }

        setFilterId(_id_client)
        await GetReportCxC(_start, _end, _id_client, (valuId !== 0 && valuId !== null) ? valuId.value : null, _loading, _view1, paymentType);
        await GetReportCredit(_start, _end);

    };


    const parseDateLocal = (dateString) => {
        const [year, month, day] = dateString.split("-").map(Number);
        return new Date(year, month - 1, day);
    };


    const handleFilterDate = async () => {
        if (!dateStart || !dateEnd) {
            createSweet("warning", "Campos incompletos", "Debes seleccionar ambas fechas.");
            return;
        }

        const start = parseDateLocal(dateStart);
        const end = parseDateLocal(dateEnd);



        if (start.getFullYear() !== end.getFullYear() || start.getMonth() !== end.getMonth()) {
            createSweet("warning", "Rango inválido", "Solo puedes filtrar un único mes.");
            return;
        }

        // await GetReportCxC(dateStart, dateEnd);
        await GetReportCxC(
            dateStart,
            dateEnd,
            null,
            null, // convenio
            false,
            false,
            paymentType // contado / crédito
        );

        await GetReportCredit(dateStart, dateEnd);


    };


    const handleCleanFilterByClient = async () => {
        let dateStart = "";
        let dateEnd = "";

        let _Year = new Date().getFullYear();
        let _Month = (new Date().getMonth() + 1);
        _Month = _Month < 10 ? `0${_Month}` : _Month;

        dateStart = `${_Year}-${_Month}-01`;
        let lastDate = new Date(_Year, _Month, 0);

        dateEnd = _Year + "-" + _Month + "-" + (lastDate.getDate() < 10 ? `0${lastDate.getDate()}` : lastDate.getDate());

        await GetReportCxC(dateStart, dateEnd);
        await GetReportCredit(dateStart, dateEnd);
        setFilterId(0)
        setValuId(0)
        setListAgreement([])
        setDataViewCompany(false)
        setPaymentType(null)


    }

    const [loadingDownload, setLoadingDownload] = useState(false);






    const DownloadReportCxc = async (_id_client, _all) => {
        console.log("🚀 ~ DownloadReportCxc ~ _id_client:", _id_client)
        console.log("🚀 ~ DownloadReportCxc ~ _all:", _all)

        setLoadingDownload(true); // 🔥 inicia loading

        let _valid = _all === 0 ? _all : _id_client;
        setLoadingIdR(_valid);

        let _start = dateStart;
        let _end = dateEnd;

        if (!_start || !_end) {

            const today = new Date();
            const _Year = today.getFullYear();
            let _Month = today.getMonth() + 1;
            _Month = _Month < 10 ? `0${_Month}` : _Month;

            _start = `${_Year}-${_Month}-01`;
            const lastDate = new Date(_Year, _Month, 0);
            _end = `${_Year}-${_Month}-${lastDate.getDate().toString().padStart(2, '0')}`;

            setDateStart(_start);
            setDateEnd(_end);

        }

        if (_urlClient === pyrsa) {
            exportToExcel()
        }

        const baseUrl = "/api/Reports/DownloadReportCxC";
        const baseUrl2 = "/api/Reports/DownloadGroupedReport";
        const isPyrsa = _urlClient === pyrsa ? baseUrl2 : baseUrl;

        const _token = localStorage.getItem("token");
        const _url =
            _id_client === null
                ? `${isPyrsa}/${dateStart}/${dateEnd}`
                : `${isPyrsa}/${dateStart}/${dateEnd}?id_company=${_id_client}${valuId && valuId !== 0 ? `&id_agreement=${valuId.value}` : ""
                }`;

        try {
            const response = await fetch(_url, {
                method: "GET",
                headers: new Headers({
                    Authorization: "Bearer " + _token,
                    "Content-Type": "application/vnd.ms-excel",
                }),
            });

            if (!response.ok) throw new Error("Error en la descarga del archivo");

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Reporte_De_Facturas.xlsx");
            document.body.appendChild(link);
            link.style.display = "none";
            link.click();
        } catch (error) {
            console.error("Error al descargar el archivo:", error);
        } finally {
            setLoadingIdR(null);
            setLoadingDownload(false); // 🔥 termina loading

        }
    };



    const GetReportCredit = async (_startDate, _endDate) => {

        try {
            const detailCredit = await getGlobalCredit(_startDate, _endDate);

            if (detailCredit.code === 200 && Array.isArray(detailCredit.data)) {
                const filteredCompanies = detailCredit.data
                    .map(company => {
                        const filteredPatients = company.patientDetails?.filter(
                            patient => patient.id_pay_method === 10
                        );

                        if (filteredPatients && filteredPatients.length > 0) {
                            return {
                                ...company,
                                patientDetails: filteredPatients
                            };
                        }

                        return null;
                    })
                    .filter(company => company !== null);

                if (filteredCompanies.length > 0) {
                    setCompanyInfo(filteredCompanies);
                } else {
                    setCompanyInfo([]);
                    createSweet("warning", "warning", "Opss..", "Sin información de créditos");
                }
            } else {
                setCompanyInfo([]);
                createSweet("warning", "warning", "Opss..", "Sin información de créditos");
            }
        } catch (error) {
            console.error("Error al obtener créditos:", error);
            setCompanyInfo([]);
            createSweet("error", "Error", "Ocurrió un error", "Inténtalo más tarde");
        } finally {
        }
    };

    const getBadgeStatus = (label) => {
        switch (label) {
            case "Vigente":
                return 'success';

            default:
                return 'danger';
        }
    };


    // ? CONFIGURATION SEARCH AGREEMENT
    const searchAgreement = async (_id) => {
        if (_id === 0) {
            if (msgs.current) {
                msgs.current.clear();
                msgs.current.show([
                    {
                        sticky: true,
                        severity: 'error',
                        icon: 'pi pi-question-circle',
                        detail: 'Debe de seleccionar un cliente'
                    },
                ]);
            }
            return;
        }

        const getAgreement = await getInformationAgreement(_id);
        if (getAgreement !== null) {
            const list = getAgreement?.map(_find => {
                return {
                    value: _find?.id_agreement,
                    label: _find?.code,
                }
            });
            setListAgreement(list);
        }
    }


    const handleChangeAgreement = (e) => {
        if (e !== null) {
            setValuId({ value: e?.value, label: e?.label })

        } else {
            setValuId(null)
        }
    }

    // ? SEARCH AGREEMENTS
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };


    // ? CONFIGURATION FILTER DATA TABLE
    const calcularTotal = () => {
        const datosFiltrados = listDetailTransactionsByClients.filter(transaction => {
            if (filterCredit && transaction.paymentCondition === "Crédito") return true;
            if (filterAccount && transaction.paymentCondition === "Pago de contado") return true;
            if (filterPayment && transaction.paymentStatus === "Pagado") return true;
            if (filterPendingPayment && transaction.paymentStatus === "Pendiente") return true;
            if (filterInvoiced && transaction.financialStatus === "Facturado") return true;
            if (filterPendigInvoiced && transaction.financialStatus === "Pendiente") return true;
            if (filterPreInvoice && transaction.financialStatus === "Prefactura") return true;
            if (filterPpd && transaction.payMethod === "PPD") return true;
            if (filterPue && transaction.payMethod === "PUE") return true;
            if (filterAmount && transaction.id_Pay_method === 1) return true;
            if (filterAmountCredit && transaction.id_Pay_method === 10) return true;
            if (filterAmountDebit && transaction.id_Pay_method === 4) return true;
            if (filterAmountTcredit && transaction.id_Pay_method === 2) return true;
            if (filterAmountTrasferencia && transaction.id_Pay_method === 8) return true;


            if (!filterCredit && !filterAccount && !filterPayment && !filterPendingPayment && !filterInvoiced && !filterPendigInvoiced && !filterPreInvoice && !filterPpd && !filterPue && !filterAmount && !filterAmountCredit && !filterAmountDebit && !filterAmountTcredit && !filterAmountTrasferencia) return true;
            return false;
        });

        const total = datosFiltrados.reduce((suma, item) => {
            const _total = item.totalWorkOrder + item.totalTax || 0;
            return suma + _total;
        }, 0);

    };

    const calculatePaymentMethod = (id_Pay_method) => {
        switch (id_Pay_method) {
            case 1:
                return "Efectivo";
            case 2:
                return "T.C";
            case 4:
                return "T.D";
            case 8:
                return "T.E";
            case 10:
                return "Crédito";
            case 28:
                return "Deposito Bancario";
            default:
                return "Desconocido";
        }
    };


    const getTransactionLabel = (_getTransactionType) => {
        if (_getTransactionType === "Pendiente") {
            return <Tag className="mr-2" style={{ fontSize: "11px" }} icon="pi pi-angle-right" severity="danger" value="Pendiente"></Tag>;
        }
        return <Tag className="mr-2" style={{ fontSize: "11px" }} icon="pi pi-angle-right" severity="success" value="Pagado"></Tag>;
    };

    const getstatusInvoice = (_invoice) => {
        if (_invoice === "Pendiente") {
            return <Tag style={{ fontSize: "11px" }} className="mr-2" icon="pi pi-angle-right" severity="warning" value="Pendiente"></Tag>;
        }
        return <Tag style={{ fontSize: "11px" }} className="mr-2" icon="pi pi-angle-right" severity='success' value="Facturado"></Tag>;
    }

    const getValueTax = (_valueTax) => {
        if (_valueTax === "8") {
            return <b className='txt-secondary' style={{ fontSize: "13px" }} >{_valueTax}%</b>;
        }
        return <b className='txt-info' style={{ fontSize: "13px" }} >{_valueTax}%</b>;
    };

    const tagInfo = (rowData) => {
        if (rowData === "Crédito") {
            return <Tag style={{ fontSize: "11px" }} className="mr-2" severity='warning' value="Crédito"></Tag>;
        }
        else if (rowData === "Cortesia") {
            return <Tag className="mr-2" style={{ fontSize: "11px" }} severity='danger' value="Cortesia"></Tag>;
        }
        return <Tag className="mr-2" style={{ fontSize: "11px" }} severity='success' value="Contado"></Tag>;
    };

    const rowExpansionTemplate = (data) => {
        const columnsPerRow = 5;

        const rows = [];
        for (let i = 0; i < data.length; i += columnsPerRow) {
            rows.push(data.slice(i, i + columnsPerRow));
        }
    }

    const [searchQuerys, setSearchQuerys] = useState("");

    const filteredData = listDetailTransactionsByClients.filter((_transaction) => {
        let match = true;

        if (filterAmount) match = match && _transaction?.id_Pay_method === 1;
        if (filterAmountCredit) match = match && _transaction?.id_Pay_method === 10;
        if (filterAmountDebit) match = match && _transaction?.id_Pay_method === 4;
        if (filterAmountTcredit) match = match && _transaction?.id_Pay_method === 2;
        if (filterAmountTrasferencia) match = match && _transaction?.id_Pay_method === 8;

        if (filterCredit) match = match && _transaction?.paymentCondition === "Crédito";
        if (filterAccount) match = match && _transaction?.paymentCondition === "Pago de contado";

        if (filterPayment) match = match && _transaction?.paymentStatus === "Pagado";
        if (filterPendingPayment) match = match && _transaction?.paymentStatus === "Pendiente";

        if (filterInvoiced) match = match && _transaction?.financialStatus === "Facturado";
        if (filterPendigInvoiced) match = match && _transaction?.financialStatus === "Pendiente";
        if (filterPreInvoice) match = match && _transaction?.financialStatus === "Prefactura";

        if (filterPpd) match = match && _transaction?.payMethod === "PPD";
        if (filterPue) match = match && _transaction?.payMethod === "PUE";

        if (searchQuerys) {
            const search = searchQuerys.toLowerCase();

            const searchMatch =
                _transaction.namePatient?.toLowerCase().includes(search) ||
                _transaction.nim?.toLowerCase().includes(search) ||
                _transaction.nameAgreement?.toLowerCase().includes(search);

            match = match && searchMatch;
        }

        return match;
    });







    const filteredClients = detailTransactionsByClients.filter(client => {
        const searchValue = searchQuery.toLowerCase();

        return (
            (client?.name_client?.toLowerCase() || "").includes(searchValue) ||
            (client?.business_name?.toLowerCase() || "").includes(searchValue) ||
            (client?.rfc_company?.toLowerCase() || "").includes(searchValue) ||
            (client?.is_micro ? "sanitaria" : "clinicos").includes(searchValue)
        );
    });


    // ? CONFIGURATION CHART GLOBAL
    const chartData = companyInfo.map(company => {
        const totalAmount = company.patientDetails
            .filter(patient => patient.status_oreder === "Vigente")
            .reduce((total, patient) => total + (patient.amount || 0), 0);

        return {
            name: company.nameCompany,
            y: totalAmount,
            id_company: company.id_company,
        };
    }
    );


    // const options = {
    //     chart: {
    //         type: "pie",
    //         height: 400,
    //         width: null,
    //         backgroundColor: layoutVersion === "dark-only" ? "#0000" : ""
    //     },

    //     title: {
    //         text: null,
    //     },

    //     plotOptions: {
    //         pie: {
    //             innerSize: "50%",
    //             dataLabels: {
    //                 enabled: true,
    //                 format: "{point.name}: {point.percentage:.1f}%"
    //             },

    //             point: {
    //                 events: {
    //                     click: function () {
    //                         const clickedId = this.id_company;
    //                         const company = companyInfo.find(
    //                             c => c.id_company === clickedId
    //                         );

    //                         setSelectedCompany(company);
    //                         setVisible(true);
    //                     }
    //                 }
    //             }
    //         }
    //     },

    //     series: [
    //         {
    //             name: "Empresa",
    //             colorByPoint: true,

    //             // 👇 SOLO LOS PRIMEROS 10
    //             data: chartData.slice(0, 10)
    //         }
    //     ]
    // };

    // * CONFURATION CREDIT DETAILS
    const [pageChart, setPageChart] = useState(1);
    const pageSize = 10;

    // 👉 TODOS LOS CLIENTES ORDENADOS DE MAYOR A MENOR
    const sortedData = [...chartData].sort((a, b) => b.y - a.y);

    // 👉 TOTAL REAL DE CLIENTES
    const totalClients = sortedData.length;

    // 👉 TOTAL DE PÁGINAS (si hay 80 = 8 páginas)
    const totalPages = Math.ceil(totalClients / pageSize);

    // 👉 RANGO ACTUAL
    const start = (pageChart - 1) * pageSize;
    const end = start + pageSize;

    // 👉 CLIENTES QUE SE VERÁN EN ESA PÁGINA
    const topData = sortedData.slice(start, end);


    const data = {
        labels: topData.map(x => x.name),
        datasets: [
            {
                data: topData.map(x => x.y),
                backgroundColor: [
                    "#0B3C5D",
                    "#328CC1",
                    "#D9B310",
                    "#1D2731",
                    "#7FB800",
                    "#FF6F61",
                    "#6A4C93",
                    "#00A8E8",
                    "#F26419",
                    "#2EC4B6"
                ],
                borderWidth: 1,
                hoverOffset: 18 // 👈 🔥 AQUÍ está la magia
            }
        ]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        cutout: "55%",

        plugins: {
            legend: {
                position: "bottom",
                labels: {
                    usePointStyle: true,
                    padding: 14,
                    boxWidth: 12,
                    boxHeight: 12
                }
            },

            tooltip: {
                callbacks: {
                    label: function (context) {
                        const label = context.label || "";
                        const value = context.raw || 0;

                        return `${label}: $${value.toLocaleString()}`;
                    }
                }
            },

            datalabels: {
                display: false
            }
        },

        // 👉 CLICK SOLO SEGMENTO
        onClick: (event, elements, chart) => {
            const points = chart.getElementsAtEventForMode(
                event,
                "nearest",
                { intersect: false },
                true
            );

            if (!points.length) return;

            const index = points[0].index;
            const clicked = topData[index];

            if (!clicked) return;

            const company = companyInfo.find(
                x => x.id_company === clicked.id_company
            );

            if (!company) return;

            setSelectedCompany(company);
            setVisible(true);
        },

        interaction: {
            mode: "nearest",
            intersect: false
        },

        onHover: (event, elements) => {
            const target = event.native?.target;

            if (target) {
                target.style.cursor =
                    elements.length > 0 ? "pointer" : "default";
            }
        },

        animation: {
            duration: 180
        }
    };

    function exportToExcel() {
        console.log("entras");

        let _array = filteredClients;
        let _Report = []

        _array.forEach((_find, key) => {

            const reportObject = {
                "Cliente": _find.name_client || "Sin nombre",
                "Razón social": _find.business_name || "N/A",
                "RFC": _find.rfc_company || "Sin nombre",
                "Total de credito": _find.totalCredit.toFixed(2) || 0,
                "Total Contado": _find.totalCash.toFixed(2) || 0,
                "Total pagado": _find.totalPaid.toFixed(2) || 0,
            };
            _Report.push(reportObject);
        });

        const worksheet = XLSX.utils.json_to_sheet(_Report);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Reporte');

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        const fileName = 'Detallado de clientes.xlsx';
        if (typeof window !== 'undefined' && window.navigator?.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(dataBlob, fileName);
        } else {
            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(url);
        }
    }

    // * GLOBAL REQUEST
    const GlobalRequest = async (method, methodUrl, nameMethod, body = null) => {
        let requestOptions = {
            method: method
        };

        if (body !== null) {
            requestOptions = {
                ...requestOptions,
                body: JSON.stringify(body)
            };
        }

        const response = await sendRequest(requestOptions, methodUrl);

        if (response.code === 200) {
            return response.data;
        }
        else {
            return null;
        }
    }

    // * FORMAT NUMBERS
    const number_format = (cantidad, decimals) => {
        cantidad += '';
        cantidad = parseFloat(cantidad.replace(/[^0-9\.]/g, ''));

        decimals = decimals || 0;

        if (isNaN(cantidad) || cantidad === 0) {
            return parseFloat(0).toFixed(decimals);
        }

        cantidad = '' + cantidad.toFixed(decimals);

        let cantidad_parts = cantidad.split('.'),
            regexp = /(\d+)(\d{3})/;

        while (regexp.test(cantidad_parts[0]))
            cantidad_parts[0] = cantidad_parts[0].replace(regexp, '$1' + ',' + '$2');

        return cantidad_parts.join('.');
    }

    return {
        loadingTotalIngress, loadingTableClients, lblTotalIngress, lblOutSideBalance, lblTotalClients,
        detailTransactionsByClients, listDetailTransactionsByClients,
        handleFilterByClient, handleFilterDate, number_format,
        handleCleanFilterByClient,

        // * FILTERS
        filterCredit, setFilterCredit,
        filterAccount, setFilterAccount,
        filterPayment, setFilterPayment,
        filterPendingPayment, setFilterPendingPayment,
        filterInvoiced, setFilterInvoiced,
        filterPendigInvoiced, setFilterPendigInvoiced,
        filterPreInvoice, setFilterPreInvoice,
        filterPpd, setFilterPpd,
        filterPue, setFilterPue,


        //* DOWNLOAD REPORT CXC
        DownloadReportCxc,

        // ? FILTER PAYMETHODS
        filterAmountCredit, setFilterAmountCredit,
        filterAmountDebit, setFilterAmountDebit,
        filterAmountTcredit, setFilterAmountTcredit,
        filterAmountTrasferencia, setFilterAmountTrasferencia,
        filterAmount, setFilterAmount,

        lblTotalPaidIngress, lblTotalPatient, loadingIdR,
        setDateStart, setDateEnd, dateStart, dateEnd, companyInfo,
        getBadgeStatus, dataViewCompany,
        listAgreement, searchAgreement, valuId, handleChangeAgreement, filterId,
        loadingView2, loadingView1

        // ? SEARCH AGREEMENTS
        , searchQuery, handleSearchChange, setsearchView1,

        // ? CONFIGURATION CHART GLOBAL
        options, selectedCompany, visible, setVisible,

        // ? CONFIGURATION FILTER DATA TABLE
        rowExpansionTemplate, filteredData, calculatePaymentMethod, getstatusInvoice, getValueTax, tagInfo
        , getTransactionLabel, filteredClients,

        // ? CONFIGURATION DATA TABLE
        expandedRows, setExpandedRows, expandedRows2, setExpandedRows2,
        globalFilter, setGlobalFilter, globalFilter2, setGlobalFilter2,
        nameCompany, setNameCompany,
        searchQuerys, setSearchQuerys,
        paymentType, setPaymentType,
        data, pageChart, setPageChart, totalPages, loadingDownload



    }
}
